import { module } from 'angular';
import App from '../../../app';

class SCR1302Controller {
	
	constructor ($scope, $state, $timeout, $uibModalInstance, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		
		this.initWindow(640, 700);
		this.initText();
		this.initSearch();
		this.initSelect();
		
		this.$timeout(() => {
			this.setGridHeight();
			this.initSysGridOption();
			this.getSysList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'), bxMsg.getMessages('manageCommSystem'));
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initSysGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
    		 {fieldName: "sysCd"}, {fieldName: "sysNm"}, {fieldName: "sysCdDesc"}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "sysCd", fieldName: "sysCd", header : { text: this.text.shortSysCd }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "sysNm", fieldName: "sysNm", header : { text: this.text.shortSysNm }, width: 100, styles: { textWrap: 'ellipse' } },
			{ name: "sysCdDesc", fieldName: "sysCdDesc", header : { text: this.text.sysCdDesc }, width: 100, styles: { textWrap: 'ellipse' } }
		]);
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true)
		};
	}
	
	getSysList(goToFirst = false){
		const {pageNumber, pageSize} = this.getPageInfo();
		let url = `/srsyss?pageNumber=${ goToFirst ? 1 : pageNumber}&pageSize=${pageSize}`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			if(goToFirst) {
				this.pageNumber = 1;
				this.$scope.$broadcast(`resetPage`, this.pageNumber);
			}
			
			this.recordsCount = data.totalCnt;
			this.dataProvider.setRows(data.srsysbsOutList);
		});
	}
	
	getPageInfo() {
		return {
			pageNumber: this.pageNumber || 1,
			pageSize: this.select.pageSize
		};
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getSysList(true);
	}
	
	search(){
		this.getSysList(true);
	}
	
	blur($event){
		$event.target.blur();
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.getSysList(num === 1);
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getSelectedRows();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.$uibModalInstance.close(this.gridView.getValues(selection[0]));
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	setGridHeight() {
		let $msgGrid = $('#grid');
		let height = this.gridService.getGridHeight(this.select.pageSize);
		
		$msgGrid.height(height);
	}

}

module(App.name).controller('SCR1302Controller', SCR1302Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1302/SCR1302.controller.js